import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";

function StudentDashboard() {
  const [tickets, setTickets] = useState([]);
  const [totalTickets, setTotalTickets] = useState(0);
  const [userData, setUserData] = useState(null);
  const [authUser, setAuthUser] = useState(null);
  const [schoolId, setSchoolId] = useState(null);

  // Watch for auth state changes
  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, (u) => setAuthUser(u || null));
    return () => unsub();
  }, []);

  // Fetch user data
  useEffect(() => {
    if (!authUser) return;

    const fetchUserData = async () => {
      try {
        const userDocRef = doc(db, "users", authUser.uid);
        const userSnap = await getDoc(userDocRef);
        if (userSnap.exists()) {
          const data = userSnap.data();
          setUserData(data);
          setSchoolId(data.schoolId);
        } else {
          console.warn("No user document found");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [authUser]);

  // Fetch student tickets
  useEffect(() => {
    if (!authUser || !schoolId) return;

    const fetchTickets = async () => {
      try {
        const ticketRef = collection(db, "schools", schoolId, "tickets");
        const q = query(ticketRef, where("studentId", "==", authUser.uid));
        const querySnapshot = await getDocs(q);
        const ticketData = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          const ts =
            data.timestamp?.toDate?.() || data.createdAt?.toDate?.() || null;
          return {
            id: doc.id,
            ...data,
            timestamp: ts,
            date: ts ? ts.toLocaleDateString() : "Unknown Date",
          };
        });

        setTickets(ticketData);
        setTotalTickets(ticketData.reduce((acc, t) => acc + (t.quantity ?? 1), 0));
      } catch (error) {
        console.error("Error fetching tickets:", error);
      }
    };

    fetchTickets();
  }, [authUser, schoolId]);

  const displayClass = userData?.class ?? userData?.advisory ?? "Unassigned";

  return (
    <div style={{ padding: "2rem" }}>
      <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
        🎯 Student Dashboard
      </h1>

      {displayClass && (
        <h2 style={{ color: "#4b5563" }}>Your Class: {displayClass}</h2>
      )}

      <div
        style={{
          backgroundColor: "#e0f2fe",
          padding: "1rem",
          borderRadius: "8px",
          margin: "1rem 0",
        }}
      >
        <h2 style={{ marginBottom: 0 }}>
          🎟 Total Tickets: {totalTickets}
        </h2>
      </div>

      <div>
        <h3 style={{ marginBottom: "0.5rem" }}>🕓 Ticket History</h3>
        {tickets.length === 0 ? (
          <p>No tickets found</p>
        ) : (
          <ul style={{ listStyle: "none", padding: 0 }}>
            {tickets
              .sort((a, b) => (b.timestamp?.getTime?.() || 0) - (a.timestamp?.getTime?.() || 0))
              .map((ticket) => (
                <li
                  key={ticket.id}
                  style={{
                    backgroundColor: "#f9fafb",
                    marginBottom: "0.5rem",
                    padding: "0.75rem",
                    borderRadius: "6px",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <strong>{ticket.quantity ?? 1} tickets</strong> —{" "}
                  {ticket.note || "No note"}
                  <br />
                  <small>
                    📅 {ticket.date} | 🧑‍🏫 Given by:{" "}
                    {ticket.givenBy?.name || "Unknown"} | 🌟 Value:{" "}
                    {ticket.valueType || "N/A"}
                  </small>
                </li>
              ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default StudentDashboard;